import { LogLevel, LoggerConfig } from '../utils/logger';
import { config, isProduction } from './app.config';

// Helper function to convert string log level to LogLevel enum
const parseLogLevel = (level: string): LogLevel => {
  switch (level.toUpperCase()) {
    case 'DEBUG':
      return LogLevel.DEBUG;
    case 'INFO':
      return LogLevel.INFO;
    case 'WARN':
      return LogLevel.WARN;
    case 'ERROR':
      return LogLevel.ERROR;
    case 'NONE':
      return LogLevel.NONE;
    default:
      return LogLevel.INFO; // Default fallback
  }
};

export const getLoggerConfig = (): LoggerConfig => {
  const prodMode = isProduction();
  const logLevel = config.logLevel
    ? parseLogLevel(config.logLevel)
    : prodMode
      ? LogLevel.INFO
      : LogLevel.DEBUG;

  return {
    level: logLevel,
    enableConsole: true,
    formatForProduction: prodMode,
  };
};

// Different configs for different environments
export const developmentConfig: LoggerConfig = {
  level: config.logLevel ? parseLogLevel(config.logLevel) : LogLevel.DEBUG,
  enableConsole: true,
  formatForProduction: false,
};

export const productionConfig: LoggerConfig = {
  level: config.logLevel ? parseLogLevel(config.logLevel) : LogLevel.INFO,
  enableConsole: true,
  formatForProduction: true,
};

export const testConfig: LoggerConfig = {
  level: LogLevel.NONE, // Disable logging in tests
  enableConsole: false,
  formatForProduction: false,
};
